import { Table, AutoSizer, InfiniteLoader, Column } from "react-virtualized";
import React from "react";
import CustomColumn from "./CustomColumn";
import isEqual from "lodash/isEqual";
import Axios from "axios";
import { frameReviewRequestDetails, frameRejectedHistory } from "./utils";

export default class InfiniteScrollTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      items: [],
      totalItemsLength: 0,
      loadedItems: 0,
      dataModified: false,
      index: undefined,
      deleted_status: false,
    };
    this.loadMore = this.loadMore.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEqual(props.data, state.data)) {
      const { data, searchAttributes, lastKey, input } = props;
      const len = data.length;
      let items = props.data.slice(0, 10);
      let body = {
        ...lastKey,
        ...searchAttributes,
        ...input,
      };
      return {
        data: [...data],
        totalItemsLength: len,
        items,
        loadedItems: items.length,
        searchCriteria: body,
      };
    }
    if (props.deleted_status !== state.deleted_status) {
      return { deleted_status: props.deleted_status };
    }
    return null;
  }

  componentDidUpdate = () => {
    if (this.state.deleted_status) {
      this.getDataOnDelete();
    }
  };

  loadMore() {
    let newItems = this.state.items;
    let startIndex = newItems.length;

    this.setState({ items: newItems }); //, searchCriteria: body });
    const promise = new Promise((resolve, reject) => {
      this.promiseResolve = resolve;
    });
    if (this.state.searchCriteria.lastEvaluatedKey)
      this.actuallyLoadMore(startIndex);
    return promise;
  }

  actuallyLoadMore(startIndex) {
    let { items, loadedItems, searchCriteria, asc } = this.state;
    const { authToken, url, searchAttributes, page } = this.props;

    Axios.defaults.headers.common["Authorization"] = authToken;
    Axios.defaults.headers.common["Pragma"] = "no-cache";

    Axios.post(url, searchCriteria)
      .then((res) => {
        let counter = startIndex;

        res.data &&
          res.data.Items &&
          res.data.Items.forEach(function (item) {
            var frameRes;
            if (page === "review") {
              frameRes = frameReviewRequestDetails(item);
            } else if (page === "rejectedHistory") {
              frameRes = frameRejectedHistory(item);
            }
            // var res = {
            //   email : item.email_id,
            //   rejected_date: item.rejected_date,
            //   company: item.custom_company
            // };
            items[counter++] = frameRes;
          });
        loadedItems += res.data.Items.length;
        let body = {
          lastEvaluatedKey: res.data.LastEvaluatedKey,
          sort_order: asc && "asc",
          ...searchAttributes,
        };

        this.setState(
          { items, loadedItems, index: undefined, searchCriteria: body },
          () => {
            // resolve the promise after data where fetched
            this.promiseResolve();
          }
        );
      })
      .catch((err) => {
        this.props.errorWhileFetch("400_SYSTEM_ERROR");
      });
  }

  getDataOnSort = (asc, datakey) => {
    const {
      authToken,
      searchAttributes,
      url,
      fetchComplete,
      errorWhileFetch,
      page,
    } = this.props;
    Axios.defaults.headers.common["Authorization"] = authToken;
    Axios.defaults.headers.common["Pragma"] = "no-cache";
    this.setState({
      asc,
      datakey,
      index: undefined,
    });

    let body = {
      // lastEvaluatedKey: this.state.input.lastEvaluatedKey,
      sort_order: asc && "asc",
      ...searchAttributes,
    };

    this.setState({
      asc,
      datakey,
      index: undefined,
      searchCriteria: body,
    });

    fetchComplete(true);
    Axios.post(url, body)
      .then((res) => {
        let data = [];
        res &&
          res.data &&
          res.data.Items.forEach(function (item) {
            if (page === "review") {
              var res = frameReviewRequestDetails(item);
            }
            // var res = {
            //   requestedDate: item.requested_date,
            //   email: item.details.email,
            //   role: item.details.custom_accessrole,
            //   email_id: item.email_id
            // };
            data.push(res);
          });
        let body = {
          lastEvaluatedKey: res.data.LastEvaluatedKey,
          sort_order: asc && "asc",
          ...searchAttributes,
        };

        this.setState(
          {
            items: data,
            loadedItems: data.length,
            index: 0,
            searchCriteria: body,
          },
          () => {
            fetchComplete(false);
          }
        );
      })
      .catch((err) => {
        errorWhileFetch("400_SYSTEM_ERROR");
        fetchComplete(false);
      });
  };

  getDataOnDelete = () => {
    const { authToken, url, searchAttributes, page } = this.props;

    Axios.defaults.headers.common["Authorization"] = authToken;
    Axios.defaults.headers.common["Pragma"] = "no-cache";
    let body = {
      ...searchAttributes,
      sort_order: this.state.asc && "asc",
    };

    Axios.post(url, body)
      .then((res) => {
        let list = [];
        res.data &&
          res.data.Items &&
          res.data.Items.forEach(function (item) {
            var frameData;
            // var res = {
            //   email : item.email_id,
            //   rejected_date: item.rejected_date,
            //   company: item.custom_company
            // };
            if (page === "review") {
              frameData = frameReviewRequestDetails(item);
            } else if (page === "rejectedHistory") {
              frameData = frameRejectedHistory(item);
            }
            list.push(frameData);
          });
        let body = {
          lastEvaluatedKey: res.data.LastEvaluatedKey,
          ...searchAttributes,
          sort_order: this.state.asc && "asc",
        };

        this.setState({
          items: list,
          loadedItems: list.length,
          index: 0,
          searchCriteria: body,
          deleted_status: false,
        });
      })
      .then((res) => {
        if (page === "rejectedHistory")
          this.props.setRejectedList(
            this.state.items,
            this.state.searchCriteria.lastEvaluatedKey
          );
        else if (page === "review")
          this.props.setReviewRequest(
            this.state.items,
            this.state.searchCriteria.lastEvaluatedKey
          );
        this.props.fetchComplete(false);
      })
      .catch((err) => {
        this.props.errorWhileFetch("400_SYSTEM_ERROR");
        this.props.fetchComplete(false);
      });
  };

  getColumns(data = []) {
    return data.map((col, index) => {
      const { customCell = null } = col;
      return (
        <Column
          {...col}
          key={index}
          dataKey={col.dataKey}
          width={col.width ? col.width : 200}
          height={100}
          label={col.label}
          headerRenderer={(data) => {
            return (
              <>
                <CustomColumn
                  {...this.props}
                  key={index}
                  col={col}
                  index={index}
                  colData={data}
                  getDataOnSort={this.getDataOnSort}
                />
              </>
            );
          }}
          cellRenderer={(data) => {
            return customCell ? customCell(data) : data.cellData;
          }}
        />
      );
    });
  }
  render() {
    const { columnData } = this.props;
    const columns = this.getColumns(columnData);
    const {
      rowHeight = 40,
      headerHeight = 100,
      rowClassName = "",
      gridClassName = "",
    } = this.props;
    return (
      <div className="infiniteScrollContainer">
        <InfiniteLoader
          isRowLoaded={({ index }) => !!this.state.items[index]}
          loadMoreRows={this.loadMore}
          rowCount={1000000}
        >
          {({ onRowsRendered, registerChild }) => (
            <AutoSizer>
              {({ width, height }) => (
                <div>
                  <Table
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    rowClassName={rowClassName}
                    headerHeight={headerHeight}
                    width={width}
                    height={height}
                    rowHeight={rowHeight}
                    gridClassName={gridClassName}
                    rowCount={this.state.items.length}
                    rowGetter={({ index }) => this.state.items[index]}
                    scrollToIndex={this.state.index}
                    gridStyle={{ zIndex: "0 !important" }}
                  >
                    {columns}
                  </Table>
                </div>
              )}
            </AutoSizer>
          )}
        </InfiniteLoader>
      </div>
    );
  }
}
